import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["status", "textarea"]

  insert(event) {
    event.preventDefault()

    const button = event.currentTarget
    const text = button.dataset.value.trim()
    const textarea = this.textareaTarget
    textarea.setRangeText(text, textarea.selectionStart, textarea.selectionEnd, "end")
    textarea.dispatchEvent(new Event("input", { bubbles: true }))
    textarea.focus()

    if (this.hasStatusTarget) {
      this.statusTarget.textContent = ""
      requestAnimationFrame(() => {
        this.statusTarget.textContent = `${button.dataset.label} inserted`
      })
    }
  }
}
